<template>
  <div id="app">
    <v-app id="inspire">
      <v-layout align-center justify-center>

        <v-snackbar
          :value="$store.getters.error"
          color="error"
          :top="true"
          :multi-line="true"
          :auto-height="true"
          :timeout="6000"
          :vertical="false"
        >
          <m-pay-error-message :error="$store.getters.error" :login="true"/>
          <v-btn dark flat @click="clearMessages">
            Close
          </v-btn>
        </v-snackbar>

        <v-flex xs12 sm8 md4>
          <v-card class="elevation-3 pb-3">

            <v-toolbar dark color="primary">
              <v-toolbar-title>Create password</v-toolbar-title>
            </v-toolbar>

            <div v-if="displayRules.showMessage">
              <v-card-text class="py-5">
                {{ message }}
              </v-card-text>
              <v-card-actions class="mr-2">
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click="returnToLoginPage">
                  Go to login page</v-btn>
              </v-card-actions>
            </div>

            <div v-else>
              <m-pay-password-form
                :loading="displayRules.loading"
                :submit-callback="createPassword"
                button-label="Create Password"
              ></m-pay-password-form>
            </div>

          </v-card>
        </v-flex>

      </v-layout>
    </v-app>
  </div>
</template>

<script>
import axios from 'axios';
import queries from '../../utils/queries';
import MPayErrorMessage from '../MPayErrorMessage';
import MPayPasswordForm from '../MPayPasswordForm';

export default {
  name: 'MPayCompleteUserRegistration',
  components: { MPayErrorMessage, MPayPasswordForm },
  data: () => ({
    displayRules: {
      loading: false,
      showMessage: false,
    },
  }),
  methods: {
    createPassword(password) {
      this.loading = true;
      axios.post(queries.createPassword(), {
        token: this.$route.query.invitation,
        newPassword: password,
      }).then((success) => {
        this.loading = false;
        if (success.data === false) {
          this.showMessage('Invitation is invalid or user has already registered');
        } else {
          this.showMessage('Password created successfully.');
        }
      }).catch((e) => {
        this.showError(e);
        this.loading = false;
      });
    },
    returnToLoginPage() {
      this.$router.push('login');
    },
    showMessage(message) {
      this.displayRules.showMessage = true;
      this.message = message;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login/MPayCompleteUserRegistration.vue